module.exports = "/_next/static/images/landing-hero-mobile-d54f75436fbd5788ab8295675e62dd1c.png";